import { CopyExperimentPayloadToJSON, CopyExperimentPayloadFromJSON, CopyExperimentsApi } from '@bookingcom/translation-registry-client';
export { CopyExperimentPayloadFromJSON, CopyExperimentPayloadToJSON, CopyExperimentsApi, dlbRetryDQSFetch, dlbRetryProdFetch, serviceMeshFetch } from '@bookingcom/translation-registry-client';
import fetch from 'node-fetch';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var TagValidationError = /** @class */ (function (_super) {
    __extends(TagValidationError, _super);
    function TagValidationError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.name = 'TagValidationError';
        // Error breaks protoype chain https://stackoverflow.com/questions/41102060/typescript-extending-error-clas
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return TagValidationError;
}(Error));
var S3FetchError = /** @class */ (function (_super) {
    __extends(S3FetchError, _super);
    function S3FetchError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.name = 'S3FetchError';
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return S3FetchError;
}(Error));
var ValidationError = /** @class */ (function (_super) {
    __extends(ValidationError, _super);
    function ValidationError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.name = 'ValidationError';
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return ValidationError;
}(Error));
var NotInitializedError = /** @class */ (function (_super) {
    __extends(NotInitializedError, _super);
    function NotInitializedError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.name = 'NotInitializedError';
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return NotInitializedError;
}(Error));
var EnvValidationError = /** @class */ (function (_super) {
    __extends(EnvValidationError, _super);
    function EnvValidationError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.name = 'EnvValidationError';
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return EnvValidationError;
}(Error));
var NotSupportedError = /** @class */ (function (_super) {
    __extends(NotSupportedError, _super);
    function NotSupportedError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.name = 'NotSupportedError';
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return NotSupportedError;
}(Error));

var DEFAULT_FORM = 'name';
// This file can be super confusing. There are broadly 3 formats adoped by list tags across representations
// Copyexperiment store (copySettingsTag):  data uses '/list/item/form' or '/list/item' since 'name' form is implied
// LingoJS (lingojsTag):  represents list tags as 'list/form' with item passed as another parameter
// What we should use to avoid confusion (qualifiedTag): The fully qualified representation is '/list/item/form' even when the form is name
// Simply flat private tags are exempted from this rule across the stack and always uses 'tag' representation without any '/'
function convertToCopyTagQuery(msgTags) {
    // MessageData can be .artifacts/extracted from extracted-tags.json
    var simpleTags = [];
    var allItemsList = new Set();
    var simpleItemsList = {};
    msgTags.forEach(function (msg) {
        var _a;
        var lingojsTag = "".concat(msg.list, "/").concat(msg.form);
        if (msg.tag) {
            simpleTags.push(msg.tag);
        }
        else if (msg.all_items) {
            allItemsList.add(lingojsTag);
        }
        else {
            simpleItemsList[lingojsTag] = simpleItemsList[lingojsTag] || new Set();
            if (msg.item) {
                simpleItemsList[lingojsTag].add(msg.item);
            }
            (_a = msg.items) === null || _a === void 0 ? void 0 : _a.forEach(function (i) { return simpleItemsList[lingojsTag].add(i); });
        }
    });
    // Once included in allItems need not be repeated
    var lingojsTagNotIncludedInAllItems = Object.entries(simpleItemsList)
        .filter(function (_a) {
        var _b = __read(_a, 2), tagStr = _b[0]; _b[1];
        return !allItemsList.has(tagStr);
    })
        .map(function (_a) {
        var _b = __read(_a, 2), tagStr = _b[0], items = _b[1];
        return (__assign(__assign({}, convertlingojsTagToCopyTagQuery(tagStr)), { items: Array.from(items) }));
    });
    return (simpleTags.length ? [{ items: simpleTags }] : []).concat(lingojsTagNotIncludedInAllItems, Array.from(allItemsList).map(function (i) { return (__assign(__assign({}, convertlingojsTagToCopyTagQuery(i)), { allItems: true })); }));
}
function convertlingojsTagToCopyTagQuery(tag) {
    // simple list/form
    var parts = tag.split('/');
    if (tag.startsWith('/') || parts.length > 2) {
        new TagValidationError("".concat(tag, " not of form list/form"));
    }
    return parts.length == 2
        ? { list: parts[0], form: parts[1], items: [] }
        : { items: [tag] };
}
function convertCopySettingsTagToQualifiedTag(tag) {
    // Add default name form to list tags to conform with lingojs standards
    // return: qualifiedTagString
    if (tag.startsWith('/')) {
        var parts = tag.substring(1, tag.length).split('/');
        return parts.length === 2
            ? "/".concat(parts[0], "/").concat(parts[1], "/").concat(DEFAULT_FORM)
            : tag;
    }
    return tag;
}
function convertCopySettingTagToLingoJsTag(tag) {
    // Variants are returned in the way lingo internally represents tags list/form
    // https://gitlab.booking.com/core/javascript/lingojs/-/blob/master/examples/with-react/src/locales/en-us.js#L15
    // Note that is it missing the leading '/'
    if (tag.startsWith('/')) {
        var parts = tag.substring(1, tag.length).split('/');
        var lingojsTag = parts.length == 3
            ? "".concat(parts[0], "/").concat(parts[2])
            : "".concat(parts[0], "/").concat(DEFAULT_FORM);
        return {
            tag: lingojsTag,
            item: parts[1],
        };
    }
    return { tag: tag };
}
function convertTagQueryToQualifiedTag(query) {
    return !query.list
        ? query.items
        : query.allItems
            ? ["/".concat(query.list, "/*/").concat(query.form)]
            : query.items.map(function (item) { return "/".concat(query.list, "/").concat(item, "/").concat(query.form); });
}
function isSameCopyTagQueries(tagQueries1, tagQueries2) {
    return (__spreadArray([], __read(new Set(tagQueries1.flatMap(function (q) { return convertTagQueryToQualifiedTag(q); }))), false).sort()
        .join('|') ===
        __spreadArray([], __read(new Set(tagQueries2.flatMap(function (q) { return convertTagQueryToQualifiedTag(q); }))), false).sort()
            .join('|'));
}
function getCopyTagQueryMatchExpressions(qualifiedTagString) {
    // tags unless list match exactly and list tags match wildcard allItems or itself
    if (qualifiedTagString.startsWith('/')) {
        var parts = qualifiedTagString
            .substring(1, qualifiedTagString.length)
            .split('/');
        if (parts.length !== 3) {
            throw new ValidationError("".concat(qualifiedTagString, " not of form 'list/item/form' or 'tag'"));
        }
        return [
            "/".concat(parts[0], "/").concat(parts[1], "/").concat(parts[2]),
            "/".concat(parts[0], "/*/").concat(parts[2]),
        ];
    }
    return [qualifiedTagString];
}
function leftJoinCopyExpTranslationsWithDictionary(copyExpTranslation, dictionary) {
    // The dictionary object returned will contain all the copy translations and
    // relevant translations from the DictionaryObject with lists that intersects with
    // the variant translations. This makes sure we don't replace translations in original dictionary
    // This is tricky since we can receive part of a list.
    return deepClone(Object.keys(copyExpTranslation).reduce(function (acc, tag) {
        var _a;
        var _b;
        // if we are dealing with plural - form plural otherwise - keep it flat
        var newTransValue = isPlural(copyExpTranslation[tag])
            ? {
                type: 'plural',
                plural: copyExpTranslation[tag],
            }
            : copyExpTranslation[tag].other;
        if (!dictionary[tag] && tag.startsWith('/')) {
            var _c = __read(convertCopySettingsTagToQualifiedTag(tag).split('/'), 4); _c[0]; var list = _c[1], item = _c[2], form = _c[3];
            // No leading '/' because that's what dictionary files use
            var key = "".concat(list, "/").concat(form);
            acc[key] = {
                type: 'list',
                items: __assign(__assign({}, (_b = (acc[key] || dictionary[key])) === null || _b === void 0 ? void 0 : _b.items), (_a = {}, _a[item] = newTransValue, _a)),
            };
        }
        else {
            acc[tag] = newTransValue;
        }
        return acc;
    }, {}));
}
function isPlural(cldr) {
    return cldr.one || cldr.many || cldr.few || cldr.two || cldr.zero;
}
function deepClone(obj) {
    if (obj === null || typeof obj !== 'object') {
        return obj;
    }
    var clone = Array.isArray(obj) ? [] : {};
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            clone[key] = deepClone(obj[key]);
        }
    }
    return clone;
}
function shouldMatchCopySettingParams(userPrams, copySettingParams) {
    return (userPrams == undefined ||
        copySettingParams == undefined ||
        copySettingParams.length == 0 ||
        userPrams.some(function (param) { return copySettingParams.includes(param); }));
}
function sortObject(obj) {
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }
    if (Array.isArray(obj)) {
        return obj.map(sortObject).sort(function (a, b) {
            if (typeof a === 'object' && a !== null) {
                return JSON.stringify(a).localeCompare(JSON.stringify(b));
            }
            return String(a).localeCompare(String(b));
        });
    }
    return Object.keys(obj)
        .sort()
        .reduce(function (result, key) {
        result[key] = sortObject(obj[key]);
        return result;
    }, {});
}
function getObjectHash(obj) {
    // Simple hashCode method, not meant to be cryptographically secure
    var sortedObj = sortObject(obj);
    var str = JSON.stringify(sortedObj);
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash; // Convert to 32-bit integer
    }
    return hash;
}

var CopyExperimentContext = /** @class */ (function () {
    function CopyExperimentContext(payload) {
        this.qualifiedTagToExpName = ((payload === null || payload === void 0 ? void 0 : payload.experimentConfigs) || []).reduce(function (acc, config) {
            Object.keys(config.settings.variants || []).forEach(function (shortTag) {
                var qualifiedTag = convertCopySettingsTagToQualifiedTag(shortTag);
                acc[qualifiedTag] = acc[qualifiedTag] || [];
                acc[qualifiedTag].push(config.experimentTagname);
            });
            return acc;
        }, {});
        this.expNameToConfig = ((payload === null || payload === void 0 ? void 0 : payload.experimentConfigs) || []).reduce(function (acc, config) {
            acc[config.experimentTagname] = config;
            return acc;
        }, {});
        this.payload = payload;
    }
    // You only call this on serverside to serialize and pass a payload to use experiments after intitial render
    // NodeJS backend apps will probably never need to use this
    CopyExperimentContext.prototype.getClientSidePayloadJSON = function (locale, params) {
        // Client side payload does not include the actual translations. This is already part of the DictionaryObject returned when you call .refresh()
        var experimentConfigs = Object.values(this.expNameToConfig || {}).filter(function (config) {
            var _a, _b, _c, _d, _e;
            return (!locale || ((_b = (_a = config.settings) === null || _a === void 0 ? void 0 : _a.languages) === null || _b === void 0 ? void 0 : _b.includes(locale))) &&
                shouldMatchCopySettingParams(params === null || params === void 0 ? void 0 : params.actions, (_c = config.settings) === null || _c === void 0 ? void 0 : _c.actions) &&
                shouldMatchCopySettingParams(params === null || params === void 0 ? void 0 : params.countries, (_d = config.settings) === null || _d === void 0 ? void 0 : _d.countries) &&
                shouldMatchCopySettingParams(params === null || params === void 0 ? void 0 : params.siteTypes, (_e = config.settings) === null || _e === void 0 ? void 0 : _e.siteTypes);
        });
        return CopyExperimentPayloadToJSON(__assign(__assign({}, this.payload), { experimentConfigs: experimentConfigs.map(function (config) { return (__assign(__assign({}, config), { settings: __assign(__assign({}, config === null || config === void 0 ? void 0 : config.settings), { translations: {} }) })); }) }));
    };
    CopyExperimentContext.fromClientSidePayloadJSON = function (json) {
        return new CopyExperimentContext(CopyExperimentPayloadFromJSON(json));
    };
    CopyExperimentContext.getNoOpContext = function () {
        return new CopyExperimentContext({
            generatedAtEpochMs: Date.now(),
            experimentConfigs: [],
        });
    };
    CopyExperimentContext.prototype.getVariants = function (locale, tag, vars, params) {
        var _this = this;
        var _a, _b;
        var qualifiedTag = tag;
        // This is the way copy experiments represent tags internally
        var copyVariantTag = tag;
        if (vars && (vars === null || vars === void 0 ? void 0 : vars.item)) {
            var _c = __read(tag.split('/'), 2), start = _c[0], end = _c[1];
            qualifiedTag = "/".concat(start, "/").concat(vars.item, "/").concat(end);
            if (end == DEFAULT_FORM) {
                copyVariantTag = "/".concat(start, "/").concat(vars.item);
            }
            else {
                copyVariantTag = "/".concat(start, "/").concat(vars.item, "/").concat(end);
            }
        }
        var relevantExperiments = (this.qualifiedTagToExpName[qualifiedTag] || [])
            .map(function (experimentTagName) { return _this.expNameToConfig[experimentTagName]; })
            .filter(function (config) {
            var _a, _b;
            return ((_b = (_a = config.settings) === null || _a === void 0 ? void 0 : _a.languages) === null || _b === void 0 ? void 0 : _b.includes(locale)) &&
                shouldMatchCopySettingParams(params === null || params === void 0 ? void 0 : params.actions, config.settings.actions) &&
                shouldMatchCopySettingParams(params === null || params === void 0 ? void 0 : params.countries, config.settings.countries) &&
                shouldMatchCopySettingParams(params === null || params === void 0 ? void 0 : params.siteTypes, config.settings.siteTypes);
        });
        if (relevantExperiments.length) {
            var selectedExp = relevantExperiments[0];
            return {
                matchFound: true,
                experimentTagName: selectedExp.experimentTagname,
                hashedExperimentTagName: selectedExp.hashedExperimentTagname,
                variants: (((_b = (_a = selectedExp.settings) === null || _a === void 0 ? void 0 : _a.variants) === null || _b === void 0 ? void 0 : _b[copyVariantTag]) || []).map(function (variant) { return convertCopySettingTagToLingoJsTag(variant); }),
            };
        }
        return { matchFound: false };
    };
    CopyExperimentContext.prototype.getRunningExperimentNames = function () {
        return Object.keys(this.expNameToConfig || {});
    };
    return CopyExperimentContext;
}());

var CopyExperimentStore = /** @class */ (function () {
    function CopyExperimentStore(extractedTags, topic, fetchFn) {
        this.tagQueries = [];
        this.initialized = false;
        this.payloadHash = 0;
        this.cachedCopyExpStoreResponse = {};
        this.setTagQueries(convertToCopyTagQuery(extractedTags));
        this.api = new CopyExperimentsApi(topic, fetchFn);
    }
    CopyExperimentStore.prototype.refresh = function (dictionaryStore, extractedTags) {
        return __awaiter(this, void 0, void 0, function () {
            var forceFetch, payload, tagQueries, data, _a, payloadHash, hasNewUpdates, collectedTranslations;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        forceFetch = !!!this.signedUrl;
                        payload = {};
                        if (extractedTags !== undefined) {
                            tagQueries = convertToCopyTagQuery(extractedTags);
                            if (!isSameCopyTagQueries(tagQueries, this.tagQueries)) {
                                this.setTagQueries(tagQueries);
                                forceFetch = true;
                            }
                        }
                        if (!forceFetch) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.api.register({ queries: this.tagQueries })];
                    case 1:
                        data = _b.sent();
                        this.signedUrl = data.signedUrl;
                        payload = this.filterPayload(data.payload);
                        return [3 /*break*/, 4];
                    case 2:
                        _a = this.filterPayload;
                        return [4 /*yield*/, this.fetchFromS3()];
                    case 3:
                        payload = _a.apply(this, [_b.sent()]);
                        _b.label = 4;
                    case 4:
                        payloadHash = getObjectHash(payload);
                        hasNewUpdates = false;
                        if (this.payloadHash !== payloadHash || !this.isInitialized()) {
                            this.payloadHash = payloadHash;
                            hasNewUpdates = true;
                        }
                        else {
                            return [2 /*return*/, __assign(__assign({}, this.cachedCopyExpStoreResponse), { hasNewUpdates: hasNewUpdates })]; // minor optimization
                        }
                        this.context = new CopyExperimentContext(payload);
                        collectedTranslations = payload === null || payload === void 0 ? void 0 : payload.experimentConfigs.reduce(function (acc, config) {
                            var _a;
                            Object.keys((_a = config.settings) === null || _a === void 0 ? void 0 : _a.translations).forEach(function (localeStr) {
                                var _a;
                                var locale = localeStr;
                                var translation = ((_a = config.settings) === null || _a === void 0 ? void 0 : _a.translations[locale]) || {};
                                acc[locale] = __assign(__assign({}, acc[locale]), (translation || {}));
                            });
                            return acc;
                        }, {});
                        this.cachedCopyExpStoreResponse = {
                            dictionaries: Object.keys(dictionaryStore.dictionaries).reduce(function (acc, localeStr) {
                                var locale = localeStr;
                                acc[locale] = leftJoinCopyExpTranslationsWithDictionary(collectedTranslations[locale] || {}, dictionaryStore.dictionaries[locale] || {});
                                return acc;
                            }, {}),
                            hasNewUpdates: hasNewUpdates,
                        };
                        this.initialized = true;
                        return [2 /*return*/, this.cachedCopyExpStoreResponse];
                }
            });
        });
    };
    CopyExperimentStore.prototype.isInitialized = function () {
        return this.initialized;
    };
    CopyExperimentStore.prototype.getContext = function () {
        if (!this.isInitialized() || !this.context) {
            return CopyExperimentContext.getNoOpContext();
        }
        return this.context;
    };
    CopyExperimentStore.prototype.fetchFromS3 = function () {
        var _this = this;
        if (!this.isInitialized() || !this.signedUrl) {
            throw new S3FetchError("Store is not initialized S3 Url: <".concat(this.signedUrl, ">"));
        }
        return fetch(this.signedUrl).then(function (res) { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (!!res.ok) return [3 /*break*/, 2];
                        // Should forceFetch on next try
                        this.signedUrl = undefined;
                        _a = S3FetchError.bind;
                        _c = (_b = "Failed to fetch payload from S3 status: <".concat(res.status, "> response: <")).concat;
                        return [4 /*yield*/, res.text()];
                    case 1: throw new (_a.apply(S3FetchError, [void 0, _c.apply(_b, [_e.sent(), ">"])]))();
                    case 2:
                        _d = CopyExperimentPayloadFromJSON;
                        return [4 /*yield*/, res.json()];
                    case 3: return [2 /*return*/, _d.apply(void 0, [_e.sent()])];
                }
            });
        }); });
    };
    CopyExperimentStore.prototype.setTagQueries = function (tagQueries) {
        this.tagQueries = tagQueries;
        this.tagQueriesStrSet = new Set(tagQueries.flatMap(function (query) { return convertTagQueryToQualifiedTag(query); }));
    };
    CopyExperimentStore.prototype.filterPayload = function (payload) {
        var _this = this;
        var _a;
        // It's a little tricky now since we need to match both lists that pulls allItems
        // Tags in the copySettings is either list/item or list/item/form or tag
        // Tags in CopyTagQueries are list/*/form or list/item/form or tag
        var experimentConfigs = (_a = payload.experimentConfigs) === null || _a === void 0 ? void 0 : _a.filter(function (config) {
            var _a;
            return Object.keys((_a = config.settings) === null || _a === void 0 ? void 0 : _a.variants).some(function (copySettingsTagStr) {
                var qualifiedTag = convertCopySettingsTagToQualifiedTag(copySettingsTagStr);
                return getCopyTagQueryMatchExpressions(qualifiedTag).some(function (matchExpr) { var _a; return (_a = _this.tagQueriesStrSet) === null || _a === void 0 ? void 0 : _a.has(matchExpr); });
            });
        });
        return __assign(__assign({}, payload), { experimentConfigs: experimentConfigs });
    };
    return CopyExperimentStore;
}());

export { CopyExperimentContext, CopyExperimentStore, EnvValidationError, NotInitializedError, NotSupportedError, S3FetchError, TagValidationError, ValidationError };
//# sourceMappingURL=index.es.js.map
